import BigNumber from 'bignumber.js'
import { useCallback, useEffect, useState } from "react"
import { use721Contract } from "./useContract";
import { useActiveWeb3React } from "./web3";


export const useMintNFT = () => {
    const contract = use721Contract();
    const { account } = useActiveWeb3React();

    const [isWhiteListed, setIsWhiteListed] = useState(false)
    const [maxlimit, setmaxlimit] = useState([])

    useEffect(() => {

        const getWhiteListed = async (_account: string) => setIsWhiteListed(await contract.isWhitelisted(_account))
        const walletOfOwner = async (_account1: string) => setmaxlimit(await contract.walletOfOwner(_account1))
        getWhiteListed(account)
         walletOfOwner(account)
    }, [account, contract,maxlimit])
    const getWhiteListeds = async (_account: string) => setIsWhiteListed(await contract.isWhitelisted(_account))

    const mint = useCallback(async () => {
        console.log("receipt33", maxlimit.length);
        console.log("isWhiteListed", isWhiteListed);

       
            if (account) {
                
                    let amount_wei = new BigNumber(0.001).shiftedBy(18).toString()

                    const tx = await contract.mint(1, { value: amount_wei,gasLimit: 5000000 });
                    const receipt = await tx.wait();
                    console.log("receipt", receipt);
               
            }
      
    }, [account, contract, isWhiteListed])


    return { mint,isWhiteListed }
}